/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const PriceGroupService = {
  /**
   * Get Screen data
   *
   * */
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/PriceGroup",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  /**
   * Bulk-fetch every quantity-break tier for the session in one call,
   * scoped only by SessionID (covers every grid level — PC1/PC2/PC3/Product).
   *
   * */
  async getQuantityBreaks(sessionId) {
    const requestScreenData = {
      url: "api/PriceGroupProductQuantityBreakSession",
      filter: `SessionId eq ${sessionId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async postQuantityBreak(payload) {
    return await ApiService.post(
      "api/PriceGroupProductQuantityBreakSession",
      payload
    );
  },

  async patchQuantityBreak(recordId, payload) {
    return await ApiService.patch(
      "api/PriceGroupProductQuantityBreakSession",
      recordId,
      payload,
      "Guid"
    );
  },

  async deleteQuantityBreak(recordId) {
    return await ApiService.delete(
      "api/PriceGroupProductQuantityBreakSession",
      recordId,
      "Guid"
    );
  },

  async getTotalCount(url, filter) {
    const requestData = {
      url : url,
      // top: '0',
      count: true,
      apply: filter
    }

    return await ApiService.oDataGet(requestData);
  },

  async postPriceGroupSessionCreate(PriceGroupCode) {
    var payload = {
      PriceGroupCode: PriceGroupCode,
    };
    var url = "api/Save_PriceGroupSessionCreate";

    return await ApiService.post(url, payload);
  },

  async postPriceGroupSessionCancel() {
    var payload = {
      SessionId: localStorage.getItem(
        `SessionId_${appConfig.VUE_APP_COOKIE_NAME}`
      ),
    };
    var url = "api/Save_PriceGroupSessionCancel";

    return await ApiService.post(url, payload);
  },

  async saveSelectedItems(url, payload) {
    return await ApiService.patch(url, payload.RecordId, payload, "Guid");
  },

  async sessionBulkInclude(url, payload) {
    return await ApiService.post(url, payload);
  },

  async savePriceGroup(payload, code) { 
    const url = `api/Save_PriceGroup`;

    if (code) {
      return await ApiService.put(url, code, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },

  async saveBulkMethod(payload) {
    const url = `api/Save_PriceGroupProductSessionMethodBulkUpdate`;
    return await ApiService.post(url, payload);
  },

  async copyPriceGroup(sourcePriceGroupID) {
    const url = `api/PriceGroup/Copy`;
    return await ApiService.post(url, { SourcePriceGroupID: sourcePriceGroupID });
  }
};

export { PriceGroupService };
